import { StackedBarChartProps } from '@procureai/ui-mui';

import { monthsInYearFormatter } from '~/components/CubeChart/CubeChart.common';

export type GroupedData<K extends string> = { [P in K]: string } & {
  series: Series[];
};

interface Series {
  value: number;
  x: string;
}

export interface DataObject {
  label: string;
  [commodityGroup: string]: number | string;
}

interface TransformDataResult {
  data: DataObject[];
  dataConfig: NonNullable<StackedBarChartProps['dataConfig']>;
}

export type TranslateFunction = (key: string) => string | undefined;

export const transformDataToStackedBarChartData = <K extends string>(
  dataGroups: GroupedData<K>[],
  groupIdentifier: K,
  t: TranslateFunction,
): TransformDataResult => {
  const result: TransformDataResult = {
    data: [],
    dataConfig: [],
  };

  if (dataGroups.length === 0) {
    return result;
  }

  const transformedData = dataGroups[0].series.map((series, seriesIndex) => {
    const dataPoint: DataObject = {
      label: monthsInYearFormatter(new Date(series.x)),
    };

    dataGroups.forEach((dataGroup, groupIndex) => {
      const commodityGroupKey = `${groupIdentifier}${groupIndex}`;
      const seriesValue = dataGroup.series[seriesIndex].value;

      if (seriesValue > 0) {
        dataPoint[commodityGroupKey] = seriesValue;
      }
    });

    return dataPoint;
  });

  const dataConfig = dataGroups.map((dataGroup, index) => {
    const dataKey = `${groupIdentifier}${index}`;
    return {
      dataKey,
      label: t(dataGroup[groupIdentifier]) ?? '',
    };
  });

  return {
    data: transformedData,
    dataConfig,
  };
};
